import React from 'react'
import styled, { css } from 'styled-components'

const colors = {
  blue: {
    filled: {
      background: '#2e8ab8',
      hover: '#3e9ac9',
      disabled: '#a3d2e5',
    },
    outlined: {
      color: '#2e8ab8',
      disabled: '#a3d2e5',
      hover: 'rgba(25, 118, 210, 0.04)',
    },
  },
  gray: {
    filled: {
      background: '#78787B',
      hover: '#8c8c8f',
      disabled: '#b0b0b2',
    },
    outlined: {
      color: '#78787B',
      disabled: '#b0b0b2',
      hover: 'rgba(120, 120, 123, 0.04)',
    },
  },
}

const outlinedStyles = css`
  background-color: transparent;
  color: ${({ color }) => colors[color].outlined.color};
  border: 1px solid ${({ color }) => colors[color].outlined.color};

  &:hover,
  &:focus {
    background-color: ${({ color }) => colors[color].outlined.hover};
  }

  &:disabled {
    background-color: transparent;
    color: ${({ color }) => colors[color].outlined.disabled};
    border-color: ${({ color }) => colors[color].outlined.disabled};
  }
`

const filledStyles = css`
  background-color: ${({ color }) => colors[color].filled.background};
  color: white;
  border: none;

  &:hover,
  &:focus {
    background-color: ${({ color }) => colors[color].filled.hover};
  }

  &:disabled {
    background-color: ${({ color }) => colors[color].filled.disabled};
    cursor: not-allowed;
    opacity: 0.6;
  }
`

const ButtonElement = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  ${({ variant }) => (variant === 'outlined' ? outlinedStyles : filledStyles)}
  ${({ width }) => width && `width: ${width};`}
`

function Button({
  onClick,
  children,
  color = 'blue',
  variant = 'filled',
  ...restOfProps
}) {
  return (
    <ButtonElement
      color={color}
      variant={variant}
      onClick={onClick}
      {...restOfProps}
    >
      {children}
    </ButtonElement>
  )
}

export default Button
